import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthGuard = () => {
  const location = useLocation();
  const authStatus = useSelector((state) => state.auth.status);
  const membershipChecked = useSelector(
    (state) => state.auth.membershipChecked
  );
  const membership = useSelector((state) => {
    const homeMembership = state.auth.homeData?.membership;
    if (homeMembership) {
      return homeMembership;
    }
    return state.auth.authData?.membership;
  });
  const isVaUser = useSelector((state) => {
    const vaAccess = state.auth.authData?.va_access;
    return (
      vaAccess === true ||
      vaAccess === "true" ||
      vaAccess === 1 ||
      vaAccess === "1"
    );
  });
  const scanOnlyMemberships = ["SCAN PRO", "SCAN PRO+"];
  const isScanOnlyMember =
    membership && scanOnlyMemberships.includes(membership);
  if (authStatus === "loading") {
    return (
      <div className="spinner">
        <i className="animate-spin bx bx-loader-alt text-4xl text-primary"></i>
      </div>
    );
  }

  if (authStatus === "authorized" && !membershipChecked) {
    return (
      <div className="spinner">
        <i className="animate-spin bx bx-loader-alt text-4xl text-primary"></i>
      </div>
    );
  }

  const isAuthenticated = authStatus !== "unauthorized";
  const allowedScanRoutes = ["/wholesale", "/settings", "/guide", "/integration"];
  const filteredAllowedScanRoutes = isVaUser
    ? allowedScanRoutes.filter((route) => route !== "/settings")
    : allowedScanRoutes;
  const isAllowedScanRoute = filteredAllowedScanRoutes.some(
    (route) =>
      location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  const defaultRoute = isScanOnlyMember ? "/wholesale" : "/home";

  if (
    isAuthenticated &&
    isVaUser &&
    location.pathname.startsWith("/settings")
  ) {
    return <Navigate to={defaultRoute} replace />;
  }

  if (isAuthenticated && membershipChecked && location.pathname === "/") {
    if (defaultRoute !== "/") {
      return <Navigate to={defaultRoute} replace />;
    }
  }

  if (isAuthenticated && isScanOnlyMember && !isAllowedScanRoute) {
    return <Navigate to="/wholesale" replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthGuard;
